// extracted by mini-css-extract-plugin
export var address = "styles-module--address--df591";
export var button = "styles-module--button--847e3";
export var buttons = "styles-module--buttons--80723";
export var contactNumber = "styles-module--contactNumber--5c62b";
export var container = "styles-module--container--f50e9";
export var desktop = "1340px";
export var giant = "2200px";
export var info = "styles-module--info--85e7d";
export var infoContent = "styles-module--infoContent--5ace4";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var logoContainer = "styles-module--logoContainer--3b324";
export var mainText = "styles-module--mainText--36774";
export var mapContainer = "styles-module--mapContainer--0de03";
export var mobile = "400px";
export var openingHours = "styles-module--openingHours--0d9fc";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var socialIcon = "styles-module--socialIcon--3d732";
export var socialLink = "styles-module--socialLink--a4f66";
export var socialLinks = "styles-module--socialLinks--b6e95";
export var tablet = "769px";
export var title = "styles-module--title--13614";